// Temporarily hidden alongside the Mood Check widget; retain the setting UI.
export const SHOW_MOOD_ACCESS_SETTING = false;
